import React, { useEffect, useState } from 'react';
import { useFormikContext } from 'formik';
import Button from 'components/control/button/button';
import {
    EButtonSize,
    EButtonType,
    TButton,
} from 'components/control/button/button.types';
import { TButtonSubmit } from './types';

const ButtonSubmit: React.FC<TButtonSubmit & Partial<TButton>> = ({
    isLoading: argIsLoading,
    styleType = EButtonType.Secondary,
    children,
    ...rest
}) => {
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const form = useFormikContext();

    useEffect(() => {
        if (form.isSubmitting || argIsLoading) {
            setIsLoading(true);
            return;
        }
        setIsLoading(false);
    }, [argIsLoading, form.isSubmitting]);

    return (
        <Button
            {...rest}
            styleType={styleType}
            size={EButtonSize.Small}
            type={'button'}
            onClick={async () => {
                await form.submitForm();
            }}
            isLoading={isLoading}
        >
            {children ? children : 'Submit'}
        </Button>
    );
};

export default ButtonSubmit;
